/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './NatureOfOperationsComponent.module.scss';
import metadata from './NatureOfOperationsComponent.metadata.json5';

function NatureOfOperationsComponent(props) {

    const {
        data: NatuOfOpeVM,
        updateWizardData,
        submissionVM,
        NatuOfOpePath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);

    const addNatuOfOpe = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            NatuOfOpeVM.value = NatuOfOpeVM.value || []

            const { _xCenter, _dtoName } = NatuOfOpeVM;

            const NatuOfOpeObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            NatuOfOpeVM.pushElement(
                NatuOfOpeObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, NatuOfOpeVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            NatuOfOpeVM.value.splice(index, 1);
            _.set(submissionVM.value, NatuOfOpePath, NatuOfOpeVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, NatuOfOpePath, NatuOfOpeVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'occ') {
                const value = (item && item.occ) ? item.occ : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = NatuOfOpeVM.length > 0 && NatuOfOpeVM.children[index].occ
                    // eslint-disable-next-line security/detect-object-injection
                    ? NatuOfOpeVM.children[index].occ.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.occ = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'subClass') {
                const value = (item && item.subClass) ? item.subClass : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = NatuOfOpeVM.length > 0 && NatuOfOpeVM.children[index].subClass
                    // eslint-disable-next-line security/detect-object-injection
                    ? NatuOfOpeVM.children[index].subClass.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.subClass = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'des') {
                const value = item.des ? item.des : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [NatuOfOpeVM, handleValueChange, translator])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`NatuOfOpeTable`]: {
            data: NatuOfOpeVM.value,
        }

    }), [NatuOfOpeVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addNatuOfOpe,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            NatuOfOpeVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [NatuOfOpeVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={NatuOfOpeVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

NatureOfOperationsComponent.propTypes = wizardProps;
export default withRouter(NatureOfOperationsComponent);
